export const ROUTE_PATH = '/bonuses-history';

export const FEATURE_NAME = 'bonusesHistoryPage';
